<template>
    <el-dialog
        v-model="centerDialogVisible"
        width="500px"
        class="el-dialog-common-bg exit-dialog"
        align-center
        @close="handleClose">
        <template #header>
            <img
                :src="image"
                v-if="image"
                alt=""
                class="n-dialog-image" />
        </template>
        <h2 class="n-c-4 n-f-bold7 n-text-center n-f-6">{{ title }}</h2>

        <p class="n-c-3 n-f-5 n-text-center n-mt-6">{{ message }}</p>

        <div class="n-flex n-flex-a-c n-mt-6 ndialog-footer n-pt-5">
            <nbutton
                v-for="(button, index) in buttons"
                :key="index"
                :type="button.type || 'secondary'"
                size="medium"
                class="n-col-2"
                @click.stop="handleButtonClick(button)">
                {{ button.text }}
            </nbutton>
        </div>
    </el-dialog>
</template>

<script lang="ts" setup>
import { ref, watch, onMounted, onUnmounted } from 'vue';

interface Button {
    text: string;
    type?: 'primary' | 'secondary' | 'danger' | 'warning' | 'success';
    callback?: () => void | Promise<void>;
}

interface Props {
    title: string;
    message: string;
    buttons: Button[];
    visible?: boolean;
    image?: string;
}

const props = withDefaults(defineProps<Props>(), {
    visible: false
});

const emit = defineEmits<{
    close: [];
}>();

const centerDialogVisible = ref(props.visible);

// 监听props变化
watch(
    () => props.visible,
    newVal => {
        centerDialogVisible.value = newVal;
    }
);

const handleClose = () => {
    centerDialogVisible.value = false;
    emit('close');
};

const handleButtonClick = async (button: Button) => {
    if (button.callback) {
        await button.callback();
    }
    handleClose();
};

const handleEscClose = (event: KeyboardEvent) => {
    if (event.key !== 'Escape') {
        return;
    }

    handleClose();
};

onMounted(() => {
    document.addEventListener('keydown', handleEscClose);
});

onUnmounted(() => {
    document.removeEventListener('keydown', handleEscClose);
});
</script>

<style lang="scss" scoped>
.ndialog-footer {
    gap: 30px;
}
</style>
<style lang="scss">
.n-dialog-image {
    height: 200px;
    display: block;
    margin: -145px auto 10px auto;
}

.el-dialog .el-dialog__header .el-dialog__headerbtn i {
    svg {
        display: none;
    }
    &:after {
        font-size: 13px !important;
    }
}
</style>
